import { render, staticRenderFns } from "./practicepreDialog.vue?vue&type=template&id=1de38a4e&scoped=true&"
import script from "./practicepreDialog.vue?vue&type=script&lang=js&"
export * from "./practicepreDialog.vue?vue&type=script&lang=js&"
import style0 from "./practicepreDialog.vue?vue&type=style&index=0&id=1de38a4e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1de38a4e",
  null
  
)

export default component.exports